import React, { useState, useContext } from 'react';
import {
  getConfigIdByDescription,
  getConfigIdByName,
  getUserEnterpriseId,
  trackUserClicks,
  getUserIdFromLocalStorage,
  getValidToken,
} from '../utils';
import { useMsal } from '@azure/msal-react';
import { ChatbotContext } from '../contexts/ChatbotContext';
import { APIContext } from '../contexts/APIContext';
import { useToast } from './ui/toast/UseToast';

export default function ThumpsUpForm(props: {
  likeButtonEnabled: any;
  thumpsUpEnableForm: any;
  responseID: any;
  FeedbackSubmit: any;
}) {
  const {
    userDetails,
    chatSessionId,
    websocketConnectionRef: { current: websocket },
    WBUId,
    AppName,
    accounts,
  } = useContext(APIContext);
  const { genArcPromptAnalyticsUId, setFeedbackSubmit } = useContext(ChatbotContext);
  const { likeButtonEnabled, thumpsUpEnableForm, responseID, FeedbackSubmit } = props;
  const [checkedItems, setCheckedItem] = useState([]);
  const [likeCustom, setLikeCustom] = useState('');
  const [submitEnable, setSubmitEnable] = useState(true);
  const [mandatory, setmandatory] = useState(false);
  // const { accounts } = useMsal();
  // Use toast() to display a toast message
  const { toast } = useToast();

  const handleCheckBoxChange = (value: any) => {
    setCheckedItem((prevItems: any) => {
      if (prevItems.includes(value)) {
        if (value === 'Other') {
          setSubmitEnable(true);
          setmandatory(false);
        }
        return prevItems.filter((item: any) => item !== value);
      } else {
        if (value === 'Other' && likeCustom.length === 0) {
          setSubmitEnable(false);
          setmandatory(true);
        }
        if (value === 'Other') {
          setmandatory(true);
        }
        return [...prevItems, value];
      }
    });
  };

  const customFeedbackHandler = (e: any) => {
    // Filter out invalid '< and >' characters
    const value = e.target.value.replace(/[<>]/g, '');
    setLikeCustom(value);
    // filter the array with others option
    const result = checkedItems.filter((item: any) => item == 'Other');
    if (result.length > 0 && value.length == 0) {
      setSubmitEnable(false);
      setmandatory(true);
    }
    if (result.length > 0 && value.length > 0) {
      setSubmitEnable(true);
    }
  };

  const handleSubmit = async () => {
    const token = await getValidToken();
    const feedBackDetails = checkedItems.map((item) => {
      return {
        ConfigurationUId: getConfigIdByDescription(userDetails.ConfigurationDetails.Feedbacks, item),
      };
    });

    toast({
      status: 'success',
      description: 'Your Feedback sucessfully submitted',
    });

    const request = {
      function: 'save_prompt_feedback',
      userId: getUserIdFromLocalStorage(),
      LoggedInUser: getUserEnterpriseId(accounts),
      ParentConfigurationUId: getConfigIdByName(userDetails.ConfigurationDetails.Feedbacks, 'Like'),
      Comments: likeCustom,
      FeedBackDetails: feedBackDetails,
      GenArcPromptAnalyticsUId: genArcPromptAnalyticsUId[responseID],
      authorization: `Bearer ${token}`,
    };
    if (websocket && websocket.state === 'Connected') {
      websocket?.send('SendMessage', request);
      thumpsUpEnableForm(false);
      likeButtonEnabled(true);
      setFeedbackSubmit(true);
      trackUserClicks(
        websocket,
        'Like',
        userDetails,
        chatSessionId,
        WBUId,
        AppName,
        accounts,
        token,
        genArcPromptAnalyticsUId[responseID]
      );
    }
  };

  const handleSkip = () => {
    thumpsUpEnableForm(false);
    likeButtonEnabled(false);
  };

  return (
    <div className="Prompt-feedback flex flex-col bg-[#FAFAFA] text-gamma-light-grey">
      <div className="border-[1px] border-gamma-bg-purple-bottom">
        <div className="flex pt-2.5">
          <div className="inline-block react-chatbot-kit-chat-bot-avatar-container ">
            <img width="24" height="24" src="/icons/Frame.svg" alt="bot icon"></img>
          </div>
          <div className="inline-block">Good to hear. Let us know more!</div>
        </div>
        <div className="ml-[3rem]">
          <div className="flex text-base">
            <div className="flex ml-50 mb-[0.125rem] block min-h-[1.5rem]  inline-block w-3/6">
              <input
                type="checkbox"
                value="I was expecting this response"
                id="I was expecting this response"
                className="accent-[#961FFC] w-4 h-4 align-middle mt-1"
                onChange={() => handleCheckBoxChange('I was expecting this response')}
              />
              <label className="inline-block pl-3 hover:cursor-pointer " htmlFor="I was expecting this response">
                I was expecting this response
              </label>
            </div>
            <div className="flex mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem] inline-block">
              <input
                type="checkbox"
                value="Easy to understand"
                className="accent-[#961FFC] w-4 h-4 text-black mt-1"
                id="Easy to understand"
                onChange={() => handleCheckBoxChange('Easy to understand')}
              />
              <label className="inline-block pl-3 hover:cursor-pointer " htmlFor="Easy to understand">
                Easy to understand
              </label>
            </div>
          </div>
          <div className="flex text-base">
            <div className="flex mb-[0.125rem] block min-h-[1.5rem]  inline-block w-3/6">
              <input
                type="checkbox"
                className="accent-[#961FFC] w-4 h-4 mt-1"
                value="Detailed response"
                id="Detailed response"
                onChange={() => handleCheckBoxChange('Detailed response')}
              />
              <label className="inline-block pl-3 hover:cursor-pointer " htmlFor="Detailed response">
                Detailed response
              </label>
            </div>
            <div className="flex mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem] inline-block">
              <input
                type="checkbox"
                value="Others (Write your response)"
                className="accent-[#961FFC] w-4 h-4 mt-1"
                id="Other"
                onChange={() => handleCheckBoxChange('Other')}
              />
              <label className="inline-block pl-3 hover:cursor-pointer " htmlFor="Other">
                Others (Write your response)
              </label>
            </div>
          </div>
          <div className="pt-3">
            {mandatory ? <img className="py-1" width="4" height="4" src="/icons/mandatory.svg" alt="bot icon" /> : null}
            <textarea
              className="Scrollbar block mb-2 text-base font-normal text-gray-900 w-11/12 height-10  border-[#000] border-[1px] outline-none resize-none pt-2 pl-3"
              rows={4}
              cols={80}
              maxLength={500}
              placeholder="Write your feedback here..."
              value={likeCustom}
              onChange={(e) => {
                customFeedbackHandler(e);
              }}
            ></textarea>
            <label className="float-right mr-10 mt-1 mb-4 text-base text-[#737373]">Max input 500 Characters</label>
          </div>
        </div>
      </div>
      <div className="float-right pt-9 bg-[#F5F5F5] ">
        {submitEnable ? (
          <button
            className="rounded-sm border border-[#000] bg-[#000000] px-4 py-2 hover:bg-[#A100FF] hover:border-[#A100FF] float-right text-white"
            onClick={() => {
              handleSubmit();
              FeedbackSubmit(false);
            }}
          >
            {' '}
            Submit Feedback
          </button>
        ) : null}
        {submitEnable ? null : (
          <button className="rounded-sm border border-[#FAFAFA] bg-[#cccccc] px-4 py-2  float-right text-white cursor-default">
            {' '}
            Submit Feedback
          </button>
        )}
        <button
          className="rounded-sm border border-[#000] bg-[#FFFFFF] px-4 py-2 mr-4 hover:bg-opacity-70 float-right"
          onClick={handleSkip}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
